import { createFileRoute } from '@tanstack/react-router';
import { useQuery } from '@tanstack/react-query';
import { Inbox, Search } from 'lucide-react';

import { Card, CardContent, CardHeader, CardTitle } from '@/components/Card/Card';
import { EmptyState } from '@/components/EmptyState/EmptyState';
import { InputGroup, InputGroupIcon, InputGroupInput } from '@/components/Input/InputGroup';
import { sessionQuery } from '@/features/auth/session';
import { Page, PageBody } from '@/layouts/Page';
import { PageHeader } from '@/layouts/PageHeader';

export const Route = createFileRoute('/_app/dashboard')({
    component: DashboardPage,
});

/*
  A placeholder until the dashboard task lands: proves that sign-in leads somewhere real,
  that the shell, header and surface render, and that the session is known.
*/
function DashboardPage() {
    const { data: user } = useQuery(sessionQuery);
    return (
        <Page surface="main">
            <PageHeader
                eyebrow={greeting()}
                title={user ? `${user.firstName} ${user.lastName}` : 'Dashboard'}
                search={
                    <InputGroup>
                        <InputGroupIcon>
                            <Search />
                        </InputGroupIcon>
                        <InputGroupInput
                            type="search"
                            placeholder="Search orders, clients, products…"
                            aria-label="Search orders, clients, products"
                        />
                    </InputGroup>
                }
            />
            <PageBody>
                <Card floating>
                    <CardHeader>
                        <CardTitle>Today</CardTitle>
                    </CardHeader>
                    <CardContent flush>
                        <EmptyState
                            icon={<Inbox />}
                            title="Nothing here yet"
                            body="Sales, notifications and the orders preview arrive with the dashboard task. Sign-in, sessions and recovery are what this build proves."
                        />
                    </CardContent>
                </Card>
            </PageBody>
        </Page>
    );
}

function greeting() {
    const hour = new Date().getHours();
    return hour < 12 ? 'Good morning' : hour < 18 ? 'Good afternoon' : 'Good evening';
}
